import { combineReducers } from 'redux';
import adminsSliceReducers from './admins/slice';
import viewPreferencesReducers from './viewPreferences/slice';
import donationReducer from './donation/reducers';
import pagesReducer from './pages/reducers';
import partnersReducer from './partners/reducers';
import payoutsReducer from './payouts/reducers';
import recipientsReducer from './recipients/reducers';
import summaryReducer from './summary/reducers';
import transactionReducer from './transaction/reducers';
import userReducer from './user/reducers';
import { adminsApi } from 'services/adminsApi';
import { transactionsDistinctRecipientsApi } from 'services/transactionsDistinctRecipientsApi';
import { donationExportApi } from 'services/donationExportApi';
import { getPayoutReportSignedUrlApi } from 'services/payoutDownloadApi';
import { nextPayoutAmountApi } from 'services/nextPayoutAmountApi';
import transactionsDistinctRecipientsReducer from './transactionsDistinctRecipients/slice';
import { baseApi } from 'services/baseApi';
import { adminRecipientsApi } from 'services/adminRecipientsApi';
import { adminCandidatesApi } from 'services/adminCandidatesApi';
import { recipientAdminsApi } from 'services/recipientAdminsApi';
import { setsApi } from 'services/setsApi';
import { eventPagesForReportApi } from 'services/eventPagesForReportApi';
import { eventTicketDownloadApi } from 'services/eventTicketDownloadApi';
import { impactScoreEligibilityApi } from 'services/impactScoreEligibilityApi';
import { recipientRaceApi } from 'services/recipientRaceApi';
import { shoppingCartApi } from 'services/shoppingCartApi';
import { clientFiltersApi } from 'services/clientFiltersApi';

export default combineReducers({
  [adminsApi.reducerPath]: adminsApi.reducer,
  admins: adminsSliceReducers,
  donation: donationReducer,
  pages: pagesReducer,
  partners: partnersReducer,
  payouts: payoutsReducer,
  recipients: recipientsReducer,
  summary: summaryReducer,
  transaction: transactionReducer,
  user: userReducer,
  viewPreferences: viewPreferencesReducers,
  transactionsDistinctRecipients: transactionsDistinctRecipientsReducer,
  [transactionsDistinctRecipientsApi.reducerPath]: transactionsDistinctRecipientsApi.reducer,
  [donationExportApi.reducerPath]: donationExportApi.reducer,
  [getPayoutReportSignedUrlApi.reducerPath]: getPayoutReportSignedUrlApi.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [adminRecipientsApi.reducerPath]: adminRecipientsApi.reducer,
  [adminCandidatesApi.reducerPath]: adminCandidatesApi.reducer,
  [recipientAdminsApi.reducerPath]: recipientAdminsApi.reducer,
  [nextPayoutAmountApi.reducerPath]: nextPayoutAmountApi.reducer,
  [setsApi.reducerPath]: setsApi.reducer,
  [eventPagesForReportApi.reducerPath]: eventPagesForReportApi.reducer,
  [eventTicketDownloadApi.reducerPath]: eventTicketDownloadApi.reducer,
  [impactScoreEligibilityApi.reducerPath]: impactScoreEligibilityApi.reducer,
  [recipientRaceApi.reducerPath]: recipientRaceApi.reducer,
  [shoppingCartApi.reducerPath]: shoppingCartApi.reducer,
  [clientFiltersApi.reducerPath]: clientFiltersApi.reducer,
});
